
const digest = 'cdb5669106ba4a91e163fc57e29dca7dda09bcfbaa9043180b8da8baf91b4deb';
const classes = {"wrapper":"_wrapper_1vtha_1","barcode":"_barcode_1vtha_5"};
const css = `._wrapper_1vtha_1 {
  padding: 12px;
}

._barcode_1vtha_5 {
  display: flex;
  justify-content: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  